module.exports = __webpack_public_path__ + "static/food-2bed536dd0a594e28744e2215667b83f.svg";